import Vue from 'vue'
import Router from 'vue-router'
import tokenStorage from '@/plugins/tokenStorage'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  // ie的路由跳转兼容
  fallback: false,
  routes: [{
    path: '/main',
    component: () => import('@/components/system/index.vue'),
    children: [
      {
        name: 'index',
        path: '/',
        component: () => import('@/components/Index.vue'),
        meta: {
          title: '主页'
        }
      },
      {
        name: 'ProcessDoneTasks',
        path: 'process-doneTasks',
        component: () => import('@/components/process/runtime/process-doneTasks.vue'),
        meta: {
          title: '已办流程'
        }
      },
      {
        name: 'settingSecurityPassword',
        path: 'setting-security-password',
        component: () => import('@/components/system/setting-security-password.vue'),
        meta: {
          title: '安全密码'
        }
      },
      {
        name: 'changePassword',
        path: 'change-password',
        component: () => import('@/components/system/change-password.vue'),
        meta: {
          title: '修改密码'
        }
      },
      {
        name: 'loginHistory',
        path: 'login-history',
        component: () => import('@/components/system/login-history.vue'),
        meta: {
          title: '登录历史'
        }
      },
      {
        name: 'processStartInstance',
        path: 'process-startInstance',
        component: () => import('@/components/process/runtime/process-startInstance.vue'),
        meta: {
          title: '发起流程'
        }
      },
      {
        name: 'process-runtime',
        path: 'process-runtime/:taskId?',
        component: () => import('@/components/process/runtime/process-runtime.vue')
      },
      {
        name: 'process-view',
        path: 'process-view/:instanceId',
        component: () => import('@/components/process/runtime/process-view.vue')
      },
      {
        name: 'ProcessDoingtasks',
        path: 'process-doingTasks',
        component: () => import('@/components/process/runtime/process-doingTasks.vue'),
        meta: {
          title: '待办流程'
        }
      },

      {
        name: 'ProcessHasInstances',
        path: 'process-hasInstances',
        component: () => import('@/components/process/runtime/process-hasInstances.vue'),
        meta: {
          title: '已发流程'
        }
      },
      {
        name: 'FormRuntime',
        path: 'form-runtime/:id',
        component: () => import('@/components/form/runtime/form-runtime'),
        props: true,
        meta: {
          title: '表单查询'
        }
      },
      {
        name: 'ReportRuntime',
        path: 'report-runtime/:id',
        component: () => import('@/components/report/runtime/report-runtime'),
        props: true,
        meta: {
          title: '报表查询'
        }
      },
      {
        name: 'ProcessInstanceList',
        path: 'process-instanceList',
        component: () => import('@/components/process/runtime/process-instanceList.vue'),
        meta: {
          title: '流程实例'
        }
      },
      {
        name: 'ProcessInstanceListSystem',
        path: 'process-instanceList-system',
        component: () => import('@/components/system/system/process-instanceList-system.vue'),
        meta: {
          title: '流程实例'
        }
      },
      {
        name: 'ProcessInstanceListEdit',
        path: 'process-instanceList-edit',
        component: () => import('@/components/process/runtime/process-instanceList-edit.vue'),
        meta: {
          title: '新流程实例'
        }
      },
      {
        name: 'loginLog',
        path: 'login-log',
        component: () => import('@/components/system/system/login-log.vue'),
        meta: {
          title: '登录日志'
        }
      },
      {
        name: 'formDesignList',
        path: 'form-design-list',
        component: () => import('@/components/form/design/definition-list.vue'),
        meta: {
          title: '表单列表'
        }
      },
      {
        name: 'form-design',
        path: 'form-design/:id?',
        component: () => import('@/components/form/design/form-design.vue'),
        props: true
      },
      {
        name: 'outside-chain-design',
        path: 'outside-chain-design/:id?',
        component: () => import('@/components/form/design/outside-chain-design.vue'),
        props: true
      },
      {
        name: 'reportDesignList',
        path: 'report-design-list',
        component: () => import('@/components/report/design/report-list.vue'),
        meta: {
          title: '报表设计列表'
        }
      },
      {
        name: 'reportDataSourceList',
        path: 'report-data-source-list',
        component: () => import('@/components/report/design/report-data-source-list.vue'),
        meta: {
          title: '报表数据源列表'
        }
      },
      {
        name: 'report-design',
        path: 'report-design/:id?',
        component: () => import('@/components/report/design/report-design.vue'),
        props: true,
        meta: {
          title: '报表设计'
        }
      },
      {
        name: 'menuList',
        path: 'menu-list',
        component: () => import('@/components/system/system/menu/menu-list.vue'),
        meta: {
          title: '菜单管理'
        }
      },
      {
        name: 'process-design',
        path: 'process-design/:id?',
        component: () => import('@/components/process/design/process-design.vue'),
        props: true,
        meta: {
          title: '流程设计'
        }
      },
      {
        name: 'processDesignList',
        path: 'process-design-list',
        component: () => import('@/components/process/design/process-definition-list.vue'),
        meta: {
          title: '流程列表'
        }
      },
      {
        name: 'processCandidate',
        path: 'process-candidate',
        component: () => import('@/components/process/design/candidate-manege.vue'),
        meta: {
          title: '候选管理'
        }
      },
      {
        name: 'FormNoticeManege',
        path: 'form-notice-manege',
        component: () => import('@/components/form/design/form-notice-manege.vue'),
        meta: {
          title: '表单通知管理'
        }
      },
      {
        name: 'contractManagementOnline',
        path: 'contract-management-online',
        component: () => import('@/components/system/system/contract-management-online.vue'),
        meta: {
          title: '电子合同管理'
        }
      },
      {
        name: 'managementOperationLog',
        path: 'management-operation-log',
        component: () => import('@/components/system/system/management-operation-log.vue'),
        meta: {
          title: '管理端操作日志'
        }
      },
      {
        name: 'postClassify',
        path: 'post-classify',
        component: () => import('@/components/system/users/post-classify.vue'),
        meta: {
          title: '岗位分类'
        }
      },
      {
        name: 'clockingSite',
        path: 'clocking-site',
        component: () => import('@/components/system/system/clocking-site.vue'),
        meta: {
          title: '考勤地址管理'
        }
      },
      {
        name: 'manageChange',
        path: 'manage-change',
        component: () => import('@/components/system/system/manage-change.vue'),
        meta: {
          title: '管理员变更'
        }
      },
      {
        name: 'basicSetting',
        path: 'basic-setting',
        component: () => import('@/components/system/system/basic-setting.vue'),
        meta: {
          title: '基本设置'
        }
      },
      {
        name: 'peopleManagement',
        path: 'people-management',
        component: () => import('@/components/system/users/people-management.vue'),
        meta: {
          title: '人员管理'
        }
      },
      {
        name: 'organization',
        path: 'organization',
        component: () => import('@/components/system/users/organization.vue'),
        meta: {
          title: '组织'
        }
      },
      {
        name: 'rolePower',
        path: 'role-power',
        component: () => import('@/components/system/users/role-power.vue'),
        meta: {
          title: '角色权限'
        }
      },
      {
        name: 'faceVerifyManagement',
        path: 'face-verify-management',
        component: () => import('@/components/system/users/face-verify-management.vue'),
        meta: {
          title: '人脸管理'
        }
      },
      {
        name: 'personalAttendanceSelect',
        path: 'personal-attendance-select',
        component: () => import('@/components/system/system/personal-attendance-select.vue'),
        meta: {
          title: '个人考勤查询'
        }
      },
      {
        name: 'attendanceManagement',
        path: 'attendance-management',
        component: () => import('@/components/system/system/attendance-management.vue'),
        meta: {
          title: '个人考勤管理'
        }
      },
      {
        name: 'peopleFielsSetting',
        path: 'people-fiels-setting',
        component: () => import('@/components/system/users/people-fiels-setting.vue'),
        meta: {
          title: '员工字段信息设置'
        }
      },
      {
        name: 'printManagement',
        path: 'print-management',
        component: () => import('@/components/system/users/print-management'),
        meta: {
          title: '打印管理'
        }
      },
      {
        name: 'peopleDetails',
        path: 'people-details/:depId?/:userId?',
        component: () => import('@/components/system/users/people-details.vue'),
        meta: {
          title: '人员详情'
        }
      },
      {
        name: 'dataManagement',
        path: 'data-management',
        component: () => import('@/components/data/data-management.vue'),
        meta: {
          title: '数据管理'
        }
      },
      {
        name: 'aliasManagement',
        path: 'alias-management',
        component: () => import('@/components/data/alias-management.vue'),
        meta: {
          title: '表单别名管理'
        }
      },
      {
        name: 'dataManagementDetail',
        path: 'data-management-detail/:id?',
        props: true,
        component: () => import('@/components/data/data-management-detail.vue'),
        meta: {
          title: '数据详情'
        }
      },
      {
        name: 'appSetting',
        path: 'app-setting',
        component: () => import('@/components/system/appDesign/app-setting.vue'),
        meta: {
          title: 'app基础设置'
        }
      },
      {
        name: 'appVersionList',
        path: 'app-version-list',
        component: () => import('@/components/system/appDesign/app-version-list.vue'),
        meta: {
          title: 'app版本管理列表'
        }
      },
      // 可视化报表begin
      {
        path: 'cooperationSituationStatistics',
        name: 'cooperation-situation-statistics',
        component: () => import('@/components/custom/page/huaao/visualReport/cooperation-situation-statistics.vue'),
        meta: {
          title: '4s店合作情况统计'
        }
      },
      {
        name: 'branchPerformanceAnalysis',
        path: 'branchPerformanceAnalysis',
        component: () => import('@/components/custom/page/huaao/visualReport/branch-performance-analysis.vue'),
        meta: {
          title: '分公司30日业绩分析'
        }
      },
      {
        name: 'branchPerformanceMonths',
        path: 'branchPerformanceMonths',
        component: () => import('@/components/custom/page/huaao/visualReport/branch-performance-months.vue'),
        meta: {
          title: '分公司月度业绩分析'
        }
      },
      {
        name: 'branchOutstandingPass',
        path: 'branchOutstandingPass',
        component: () => import('@/components/custom/page/huaao/visualReport/branch-outstanding-pass.vue'),
        meta: {
          title: '分公司优秀及合格店数量'
        }
      },
      {
        name: 'branchSaleAnalysis',
        path: 'branchSaleAnalysis',
        component: () => import('@/components/custom/page/huaao/visualReport/branch-sale-analysis.vue'),
        meta: {
          title: '分公司销售件均分析'
        }
      },
      {
        name: 'branchNotQualifiedAnalysis',
        path: 'branchNotQualifiedAnalysis',
        component: () => import('@/components/custom/page/huaao/visualReport/branch-notQualified-analysis.vue'),
        meta: {
          title: '当月未达标经销商分析'
        }
      },
      {
        name: 'branchSaleContrast',
        path: 'branchSaleContrast',
        component: () => import('@/components/custom/page/huaao/visualReport/branch-sale-contrast.vue'),
        meta: {
          title: '分公司销售柱状对比图'
        }
      },
      {
        name: 'Noting',
        path: 'noting',
        component: () => import('@/components/system/nothing.vue'),
        meta: {
          title: ''
        }
      },
      {
        name: 'TimingTask',
        path: 'timing-task',
        component: () => import('@/components/system/system/timing-task.vue'),
        meta: {
          title: '定时操作'
        }
      },
      {
        name: 'TimingTaskSystem',
        path: 'timing-task-system',
        component: () => import('@/components/system/system/timing-task-system.vue'),
        meta: {
          title: '定时操作'
        }
      },
      {
        name: 'CustomFunction',
        path: 'custom-function',
        component: () => import('@/components/system/system/custom-function.vue'),
        meta: {
          title: '自定义函数'
        }
      },
      {
        name: 'ProcessUsage',
        path: 'process-usage',
        component: () => import('@/components/system/system/process-usage.vue'),
        meta: {
          title: '流程使用情况统计表'
        }
      },
      {
        name: 'PermissionHistory',
        path: 'permission-history',
        component: () => import('@/components/system/system/permission-history.vue'),
        meta: {
          title: '权限历史记录'
        }
      },
      {
        name: 'PermissionBlacklist',
        path: 'permission-blacklist',
        component: () => import('@/components/system/system/permission-blacklist.vue'),
        meta: {
          title: '权限黑名单'
        }
      },
      {
        name: 'PageRuntime',
        path: 'page-runtime/:id',
        component: () => import('@/components/page/runtime/page-runtime.vue'),
        meta: {
          title: '高级页面运行'
        }
      }
    ]
  },
  {
    name: 'CustomPrint',
    path: '/custom-print',
    component: () => import('@/components/report/design/custom-print.vue'),
    meta: {
      title: '自定义打印'
    }
  },
  {
    name: 'ReportFullScreen',
    path: '/report-full-screen',
    component: () => import('@/components/report/runtime/report-full-screen.vue'),
    meta: {
      title: '报表'
    }
  },
  {
    name: 'login',
    path: '/',
    component: () => import('@/components/system/login.vue')
  },
  {
    name: 'firstChangePassword',
    path: '/first-change-password',
    component: () => import('@/components/system/first-change-password.vue'),
    meta: {
      title: '设置密码'
    }
  },
  {
    name: 'forgetPassword',
    path: '/forget-password',
    component: () => import('@/components/system/forget-password.vue'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    name: 'qxyRegister',
    path: '/register',
    component: () => import('@/components/system/register.vue'),
    meta: {
      title: '用户注册'
    }
  },
  {
    name: 'appDownload',
    path: '/app',
    component: () => import('@/components/system/appDesign/app-download.vue'),
    meta: {
      title: 'APP下载'
    }
  },
  // app扫码之后访问的下载页
  {
    name: 'oldAppDownLoad',
    path: '/app-download/:id?',
    component: () => import('@/components/system/appDesign/app-download.vue'),
    meta: {
      title: 'APP下载'
    }
  },
  {
    name: 'showInfo',
    path: '/show-info',
    component: () => import('@/components/custom/page/huaao/show-info.vue'),
    meta: {
      title: 'TQ'
    }
  },
  {
    name: 'filePreview',
    path: '/file-preview',
    component: () => import('@/components/form/runtime/components/file-preview.vue'),
    meta: {
      title: '文件预览'
    }
  },
  {
    name: 'imagePreview',
    path: '/image-preview',
    component: () => import('@/components/form/runtime/components/image-preview.vue'),
    meta: {
      title: '图片预览'
    }
  },
  {
    name: 'formRuntimeOutsideChain',
    path: '/tt/:id',
    component: () => import('@/components/form/runtime/form-runtime-outside-chain.vue'),
    props: true
  },
  {
    name: 'publicPreview',
    path: '/public-preview',
    component: () => import('@/globalComponent/publicPreview/public-preview.vue'),
    meta: {
      title: '文件预览'
    }
  },
  {
    name: 'tbhImagePreview',
    path: '/tbh-image-preview',
    component: () => import('@/globalComponent/publicPreview/components/tbh-image-preview.vue'),
    meta: {
      title: '图片预览'
    }
  },
  {
    name: 'commitHash',
    path: '/commit-hash',
    component: () => import('@/components/system/commit-hash.vue'),
    meta: {
      title: '代码版本'
    }
  }
  ]
})

router.beforeEach((to, from, next) => {
  if (['login', 'firstChangePassword', 'forgetPassword', 'qxyRegister', 'appDownload', 'oldAppDownLoad', 'showInfo', 'filePreview', 'imagePreview', 'publicPreview', 'formRuntimeOutsideChain', 'CustomPrint', 'tbhImagePreview', 'commitHash', 'ReportFullScreen'].includes(to.name)) {
    next()
  } else {
    const token = tokenStorage.getToken()

    if (!to.query.token && from.query.token) {
      // 跳转携带 token
      next({
        path: to.path,
        query: { ...to.query, token: from.query.token }
      })
    } else if (to.name !== 'index' && !from.name) {
      // 刷新重定向到首页
      next({
        name: 'index',
        query: { token: to.query.token },
        replace: true
      })
    } else if (!token || !token.endsWith(to.query.token)) {
      // token 丢失或与链接中的不匹配则提示失效
      tokenStorage.confirm()
        .then(() => {
          next({ name: 'login' })
        })
        .catch(() => {
          next(false)
        })
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js